<template>
  <div class="relative min-h-screen pb-16 pt-navbar-height">
    <Container indent="lg-but-on-mobile-default" class="mx-auto mt-[10vh] w-full">
      <div class="mx-auto max-w-container-text">
        <h1 v-animate-in-from-bottom class="mb-5 typo-heading-xl sm:typo-heading-3xl xl:mt-16">
          {{ $t('search.search') }}
        </h1>
        <Search />
      </div>
    </Container>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  name: 'search',
})

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    de: '/suche',
    fr: '/recherche',
    en: '/search',
  },
})

const { t } = useI18n()

useHead({
  title: t('search.page_title'),
  meta: [
    {
      name: 'description',
      content: t('search.page_description'),
    },
    {
      name: 'keywords',
      content: t('search.keywords'),
    },
  ],
})

const emit = defineEmits<{
  'update:entry': [entry: PageQuery['entry']]
}>()
// Update the entry. The entry is used by the lang switcher and other components.
emit('update:entry', null)
</script>
